import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { PersistenceStateUsingContext } from "@/shared/lib/persistence-state/persistence-state-info";
import { CompanyReferenceListTable } from "@/routes/base-data/processes/qpm/company-references/_components/company-reference-list-table";

export function CompanyReferencesRoutePage() {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between gap-2">
          <CardTitle>{t("Firmenreferenzen")}</CardTitle>
          <PersistenceStateUsingContext />
        </div>
        <CardDescription>
          {t("Hier können Sie Firmenreferenzen anlegen und bearbeiten.")}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <CompanyReferenceListTable />
      </CardContent>
    </Card>
  );
}
